<template>
  <div class="offer-loader">
    <div class="img">
      <content-loader
        :height="170"
        :width="173"
        primaryColor="#ebebeb"
        secondaryColor="#f5f5f5"
      >
        >
        <rect x="0" y="0" rx="3" ry="3" width="173" height="170" />
      </content-loader>
    </div>
    <div class="main-text">
      <content-loader
        :height="12"
        :width="152"
        primaryColor="#ebebeb"
        secondaryColor="#f5f5f5"
      >
        <rect x="0" y="0" rx="3" ry="3" width="152" height="12" />
      </content-loader>
    </div>
    <div class="subtext-1">
      <content-loader
        :height="12"
        :width="95"
        primaryColor="#ebebeb"
        secondaryColor="#f5f5f5"
      >
        <rect x="0" y="0" rx="3" ry="3" width="95" height="12" />
      </content-loader>
    </div>
    <div class="subtext-2">
      <content-loader
        :height="12"
        :width="122"
        primaryColor="#ebebeb"
        secondaryColor="#f5f5f5"
      >
        <rect x="0" y="0" rx="3" ry="3" width="122" height="12" />
      </content-loader>
    </div>
    <div class="price">
      <content-loader
        :height="17"
        :width="83"
        primaryColor="#ebebeb"
        secondaryColor="#f5f5f5"
      >
        <rect x="0" y="0" rx="3" ry="3" width="83" height="17" />
      </content-loader>
    </div>
    <div class="store">
      <content-loader
        :height="10"
        :width="123"
        primaryColor="#ebebeb"
        secondaryColor="#f5f5f5"
      >
        <rect x="0" y="0" rx="3" ry="3" width="123" height="10" />
      </content-loader>
    </div>
    <div class="button">
      <content-loader
        :height="30"
        :width="153"
        primaryColor="#ebebeb"
        secondaryColor="#f5f5f5"
      >
        <rect x="0" y="0" rx="3" ry="3" width="153" height="30" />
      </content-loader>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferPreload"
};
</script>

<style lang="scss">
.offer-loader {
  margin: 0 10px 20px;
  border: 1px solid #ebebeb;
  width: 173px;
  height: 375px;
  .main-text {
    width: 152px;
    height: 12px;
    margin: 0 auto 7px auto;
  }
  .subtext-1 {
    width: 95px;
    height: 12px;
    margin: 0 auto 7px auto;
  }
  .subtext-2 {
    width: 122px;
    height: 12px;
    margin: 0 auto 35px auto;
  }
  .price {
    width: 83px;
    height: 17px;
    margin: 0 auto 26px auto;
  }
  .store {
    margin: 0 auto 20px auto;
    width: 123px;
    height: 10px;
  }
  .button {
    width: 153px;
    height: 30px;
    margin: 0 auto;
  }
}
.offer-loader svg {
  width: 100%;
  height: 100%;
}
</style>
